<script>
import Auth from "../../layouts/auth";
import appConfig from "../../../../app.config";
import { redirectToMicrosoft } from "@/helpers/authservice/sso";

import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      typePass: "password",
      showMypass: false,
    };
  },
  components: {
    Auth,
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    notificationAutoCloseDuration() {
      return this.$store && this.$store.state.notification ? 5 : 0;
    },
  },
  created() {},
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const { username, password } = this;
        if (username && password) {
          this.$store.dispatch("authfack/login", {
            username,
            password,
          });
          this.$store.dispatch("notification/clear");
        }
      }
    },
    loginWithMicrosoft() {
      this.$store.dispatch("notification/clear");
      redirectToMicrosoft();
    },
    showPass() {
      if(this.showMypass) {
        this.typePass = "password";
        this.showMypass = false;
      } else {
        this.typePass = "text";
        this.showMypass = true;
      }
    }
  },
};
</script>

<template>
  <Auth>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <div class="auth-logo">
                <router-link to="/" class="logo logo-dark text-center">
                  <span class="logo-lg">
                    <img
                      src="@/assets/images/logo-dark.png"
                      alt=""
                      height="22"
                    />
                  </span>
                </router-link>

                <router-link to="/" class="logo logo-light text-center">
                  <span class="logo-lg">
                    <img
                      src="@/assets/images/logo-light.png"
                      alt=""
                      height="22"
                    />
                  </span>
                </router-link>
              </div>
              <p class="text-muted mb-4 mt-3">
                Enter your username and password to access admin panel.
              </p>
            </div>

            <form action="#" @submit.prevent="tryToLogIn">
              <b-alert
                :variant="notification.type"
                class="mt-3"
                v-if="notification.message"
                :show="notificationAutoCloseDuration"
                dismissible
                >{{ notification.message }}</b-alert
              >

              <b-alert
                variant="danger"
                class="mt-3"
                v-model="isAuthError"
                :show="notificationAutoCloseDuration"
                dismissible
                >{{ authError }}</b-alert
              >
              <div class="form-group mb-3">
                <label for="username">Username</label>
                <input
                  class="form-control"
                  v-model="username"
                  type="text"
                  id="username"
                  placeholder="Enter your username"
                  :class="{ 'is-invalid': submitted && $v.username.$error }"
                />
                <div
                  v-if="submitted && $v.username.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.username.required">Username is required.</span>
                  <span v-if="!$v.username.username"> Please enter valid username.</span>
                </div>
              </div>

              <div class="form-group mb-3">
                <label for="password">Password</label>
                <div class="input-group input-group-merge">
                  <input
                    v-model="password"
                    :type="typePass"
                    id="password"
                    class="form-control"
                    placeholder="Enter your password"
                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                  />
                  <span class="input-group-append">
                    <button
                      type="button"
                      class="btn waves-effect waves-light btn-secondary"
                      v-on:click="showPass()"
                    >
                      <i v-if="showMypass" class="fa fa-eye"></i>
                      <i v-if="!showMypass" class="fa fa-eye-slash"></i>
                    </button>
                  </span>
                  <div
                    v-if="submitted && !$v.password.required"
                    class="invalid-feedback"
                  >
                    Password is required.
                  </div>
                </div>
              </div>

              <!-- <div class="form-group mb-3">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkbox-signin"
                    checked
                  />
                  <label class="custom-control-label" for="checkbox-signin"
                    >Remember me</label
                  >
                </div>
              </div> -->

              <div class="form-group mb-0 text-center">
                <button class="btn btn-primary btn-block" type="submit">
                  Log In
                </button>
              </div>
            </form>

            <div class="text-center mt-3">
              <p class="text-muted mb-2">atau</p>
              <button
                type="button"
                class="btn btn-outline-secondary btn-block"
                @click="loginWithMicrosoft"
              >
                <i class="mdi mdi-microsoft mr-1"></i> Sign in with Microsoft
              </button>
            </div>

            <!-- <div class="text-center">
              <h5 class="mt-3 text-muted">Sign in with</h5>
              <ul class="social-list list-inline mt-3 mb-0">
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item border-purple text-purple"
                    ><i class="mdi mdi-facebook"></i
                  ></a>
                </li>
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item border-danger text-danger"
                    ><i class="mdi mdi-google"></i
                  ></a>
                </li>
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item border-info text-info"
                    ><i class="mdi mdi-twitter"></i
                  ></a>
                </li>
                <li class="list-inline-item">
                  <a
                    href="javascript: void(0);"
                    class="social-list-item border-secondary text-secondary"
                    ><i class="mdi mdi-github"></i
                  ></a>
                </li>
              </ul>
            </div> -->
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="row mt-3">
          <div class="col-12 text-center">
            <p>
              <router-link to="/forgot-password" class="text-muted ml-1"
                >Forgot your password?</router-link
              >
            </p>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Auth>
</template>
